export const Reports = () => {
  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 4H9.125C8.56141 4 8.02091 4.23178 7.6224 4.64437C7.22388 5.05695 7 5.61652 7 6.2V23.8C7 24.3835 7.22388 24.9431 7.6224 25.3556C8.02091 25.7682 8.56141 26 9.125 26H21.875C22.4386 26 22.9791 25.7682 23.3776 25.3556C23.7761 24.9431 24 24.3835 24 23.8V10L18 4Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 4V10H24"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="10.6"
        y1="16.4"
        x2="20.4"
        y2="16.4"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="10.6"
        y1="13.4"
        x2="20.4"
        y2="13.4"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="10.6"
        y1="19.4"
        x2="20.4"
        y2="19.4"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="10.6"
        y1="22.4"
        x2="20.4"
        y2="22.4"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  )
}
